import { z } from 'zod';

export const ESTIMATED_TIME_UNITS = ['minutes', 'hours', 'days', 'weeks', 'months'] as const;
export const DELIVERY_PRICING_MODE = ['ZONE_PRICE', 'COURIER_QUOTE'] as const;
export const COURIER_SORT_BY = ['distance', 'price'] as const;
export const EXTERNAL_COURIER_UNAVAILABLE_ACTION = ['FALLBACK_TO_ZONES', 'REJECT_DELIVERY_ORDER'] as const;
// export const COURIER_SORT_DIR = ['asc', 'desc'] as const;
export const DeliveryPricingModeSchema = z.enum(DELIVERY_PRICING_MODE);
export const CourierSortBySchema = z.enum(COURIER_SORT_BY);
export const ExternalCourierUnavailableActionSchema = z.enum(EXTERNAL_COURIER_UNAVAILABLE_ACTION);
// export const CourierSortDirSchema = z.enum(COURIER_SORT_DIR);

export const EstimatedTimeSchema = z.object({
    min: z.number().optional(),
    max: z.number().optional(),
    unit: z.enum(ESTIMATED_TIME_UNITS).optional()
});

export const PointSchema = z.object({
    lat: z.number().optional(),
    lng: z.number().optional()
});

export const CircleSchema = z.object({
    center: PointSchema.optional(),
    radius: z.number().optional()
});

export const RectangleSchema = z.object({
    topLeft: PointSchema.optional(),
    bottomRight: PointSchema.optional()
});

export const DeliveryZoneSchema = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    minCart: z.number().optional(),
    deliveryFee: z.number().optional(),
    deliveryFeePerKm: z.number().optional(),
    customEstimatedDeliveryTime: EstimatedTimeSchema.optional(),
    shapeType: z.enum(['polygon', 'circle', 'rectangle']).optional(),
    polygonArea: z.array(PointSchema).optional(),
    circleArea: CircleSchema.optional(),
    rectangleArea: RectangleSchema.optional(),
    isActive: z.boolean().optional()
});

export const DeliveryteamDeliveryZoneSchema = DeliveryZoneSchema.omit({
    minCart: true,
    customEstimatedDeliveryTime: true,
});

export type Point = z.infer<typeof PointSchema>;
export type Circle = z.infer<typeof CircleSchema>;
export type Rectangle = z.infer<typeof RectangleSchema>;
export type DeliveryZone = z.infer<typeof DeliveryZoneSchema>;
export type DeliveryteamDeliveryZone = z.infer<typeof DeliveryteamDeliveryZoneSchema>;
export type EstimatedTime = z.infer<typeof EstimatedTimeSchema>;
export type DeliveryPricingMode = z.infer<typeof DeliveryPricingModeSchema>;
export type CourierSortBy = z.infer<typeof CourierSortBySchema>;
export type ExternalCourierUnavailableAction = z.infer<typeof ExternalCourierUnavailableActionSchema>;
// export type CourierSortDir = z.infer<typeof CourierSortDirSchema>;